import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import intersectionBy from 'lodash/intersectionBy';
import MessageBox from 'yoda-core-components/lib/components/MessageBox/MessageBox';
import getBrowserHistory from 'yoda-core-components/lib/navigation/history/getBrowserHistory';
import Button from 'yoda-core-components/lib/components/Button';
import {
    URL_CHECKOUT_SHIPPING,
    SRV_BOPIS_STORE_DISTANT_FROM_ZIP,
    SRV_STS_STORE_DISTANT_FROM_ZIP,
} from 'yoda-checkout-components/lib/common/Constants';
import * as findStoresActions from 'yoda-site-components/lib/actions/FindStoresAction';
import analyticsAction from 'yoda-site-components/lib/actions/AnalyticsAction';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';

const formErrorContent = [];
const errorsFromServer = [
    { code: SRV_STS_STORE_DISTANT_FROM_ZIP },
    { code: SRV_BOPIS_STORE_DISTANT_FROM_ZIP },
];

function DistantStoreMessage({
    selectedStore,
    actions,
    orderBillingInfo,
    isSDPUSection,
    warnings,
    context,
}) {
    const [isDAConsidered, setIsDAConsidered] = useState(false);
    const availableWarnings = intersectionBy(errorsFromServer, warnings, 'code');

    function triggerDAErrors(errorMessage) {
        actions.triggerFormError(errorMessage);
    }

    function openFindStoreSlider() {
        const { preferences: { defaultRadius = 75 } = {} } = context;
        const { zip = '' } = orderBillingInfo;
        if (zip) {
            isSDPUSection
                ? (window.location.href = `/cart?zipcode=${zip}`)
                : getBrowserHistory().push(`${URL_CHECKOUT_SHIPPING}?from=review`);
            const payload = {
                zipCode: zip,
                miles: defaultRadius,
            };
            actions.findStores(payload);
        }
        actions.openSlidePanel();
    }

    function renderDistantBillingMessage() {
        const {
            storeDetails: { name, city, state },
        } = selectedStore;
        const errorMessage = `${name} in ${city}, ${state} is a long distance from your billing address. `;
        if (name && city && state && !isDAConsidered) {
            formErrorContent.push({ errorDescription: errorMessage });
            availableWarnings.length === formErrorContent.length &&
                triggerDAErrors(formErrorContent);
            setIsDAConsidered(true);
        }
        return (
            <p>
                {errorMessage}
                <Button
                    buttonType="Link"
                    size="Md"
                    automationId="change-my-location-button"
                    onClick={openFindStoreSlider}
                >
                    Change my store location
                </Button>
            </p>
        );
    }
    return (
        <div>
            {!isEmpty(get(selectedStore, 'storeDetails', {})) && (
                <MessageBox
                    level="section"
                    hasClose={false}
                    automationId="at-distant-store-message"
                    theme={dt(['!mb-6'])}
                >
                    {renderDistantBillingMessage()}
                </MessageBox>
            )}
        </div>
    );
}

DistantStoreMessage.defaultProps = {
    actions: {},
    selectedStore: {},
    orderBillingInfo: {},
    context: {},
};

DistantStoreMessage.propTypes = {
    actions: PropTypes.objectOf(PropTypes.func),
    selectedStore: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    orderBillingInfo: PropTypes.objectOf(PropTypes.object),
    isSDPUSection: PropTypes.bool.isRequired,
    warnings: PropTypes.array.isRequired,
    context: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

const mapStateToProps = ({ orderBillingInfo, orderInfo, context }) => ({
    orderBillingInfo,
    context,
    warnings: get(orderInfo, 'status.warnings', []),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            triggerFormError: analyticsAction.triggerFormError,
            ...findStoresActions,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(DistantStoreMessage);
